import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import UserServicesFactory from '../../user/Services/factory.js'
import {DraftMappersFactory} from '../Mappers/factory.js'
import {DraftServicesFactory} from '../Services/factory.js'

export class EditDraftAdPublisherUseCase extends UseCase {
  #editDraftService
  #fromDraftParamToRequestDraftValueObjectMapper
  #getCurrentUserService

  constructor({config}) {
    super()
    this.#editDraftService = DraftServicesFactory.editDraftService({config})
    this.#fromDraftParamToRequestDraftValueObjectMapper =
      DraftMappersFactory.fromDraftParamToRequestDraftValueObjectMapper({
        config
      })
    this.#getCurrentUserService = UserServicesFactory.getCurrentUserService({
      config
    })
  }

  static create({config}) {
    return new EditDraftAdPublisherUseCase({config})
  }

  @tracer({metric: 'EditDraftAdPublisherUseCase#execute'})
  @inlineError
  async execute({adId, categoryId, fields, images}) {
    const userEntity = await this.#getCurrentUserService.execute()
    const userId = userEntity ? await userEntity.getId() : null

    const requestDraftVO = this.#fromDraftParamToRequestDraftValueObjectMapper
      .setFields(fields)
      .setDraftId(adId)
      .setImages(images)
      .setUserId(userId)
      .map()

    const [error, response] = await this.#editDraftService.execute({
      categoryId,
      requestDraftVO,
      userEntity
    })

    if (error) return Promise.reject(error)

    return response.toJSON()
  }
}

export const factory = EditDraftAdPublisherUseCase.create
